import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import ServiceForm from '../modules/ServiceForm';

class NewServicePage extends Component {
  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  getInitialValues = () => {
    const initialValues = { showOnHomepage: true, headerImageLarge: {} };
    const { state } = this.props.location;
    if (!state) {
      return initialValues;
    } else {
      return { ...initialValues, lang: state.lang };
    }
  };

  render() {
    return (
      <Layout>
        <Container>
          <h1>Nová služba</h1>
          <ServiceForm
            config={this.getConfig()}
            initialValues={this.getInitialValues()}
          />
        </Container>
      </Layout>
    );
  }
}

export default NewServicePage;



// WEBPACK FOOTER //
// ./src/pages/NewServicePage.js